export default __webpack_public_path__ + "static/media/location.d8fadb84.svg";